import { createFileRoute } from "@tanstack/react-router"
import { BottomNav, type TabId } from "~/components/layout/bottom-nav"
import { isTabId, tabIds, TabContainer } from "~/components/layout/tab-container"
import { HomeHeader } from "~/components/home-header"

type IndexSearch = { tab: TabId; eventId?: number; pay?: "return" }

export const Route = createFileRoute("/")({
  validateSearch: (search: Record<string, unknown>): IndexSearch => {
    const tab = isTabId(search.tab) ? search.tab : tabIds[0]
    const eventId = Number(search.eventId)
    const out: IndexSearch = { tab }
    if (Number.isFinite(eventId)) out.eventId = eventId
    if (search.pay === "return") out.pay = "return"
    return out
  },
  component: IndexPage,
})

function IndexPage() {
  const { tab } = Route.useSearch()

  return (
    <div className="flex flex-col">
      {tab !== "profile" && <HomeHeader />}
      <TabContainer tab={tab} />
      <BottomNav activeTab={tab} />
    </div>
  )
}
